export const PRE_LOGIN_STATE_KEY = 'cognito-pre-login-state'
